import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box
} from "@mui/material";
import { useTranslation } from "react-i18next";

const ConfirmDeleteDialog = ({ open, onClose, onConfirm }) => {

    const { t } = useTranslation("confirmDeleteDialog");

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            
            <DialogTitle>{t("title")}</DialogTitle>

            <DialogContent>
                <Box mb={2}>
                    {t("message")}
                </Box>
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                    {t("cancel")}
                </Button>

                <Button
                    variant="contained"
                    color="error"
                    onClick={() => {
                        onConfirm();
                        onClose();
                    }}
                >
                    {t("delete")}
                </Button>
            </DialogActions>

        </Dialog>
    );
};

export default ConfirmDeleteDialog;
